// @ts-nocheck
import { Box, Link, Typography } from '@material-ui/core'
import { Star } from '@material-ui/icons'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'

import UploadImg from '../../../../../assets/images/upload-logo.png'
import { isNullOrEmpty, noop } from '../../../../../helpers/utils'
import useStyles from '../../allEnrollments/ProgramCourses.Style'

function AddOnPrograms({
  programDetail,
  addOnProgramDetailToggle,
  readOnlyMode,
  addOnProgramRatings,
  addOnProgramReviewSettings,
  addOnProgramSaved,
}) {
  const { t } = useTranslation()
  const classes = useStyles()
  return (
    <>
      <Box width="100%" display="flex" alignItems="center">
        <Box
          width="100%"
          className={`program-list ${addOnProgramSaved?.length && `program-selected`}`}
          p={2}
          display="flex"
          alignItems="flex-start"
          justifyContent="flex-start"
          flexDirection={{ xs: 'column', sm: 'row' }}
          position={'relative'}
          mt={2}
        >
          <Box position={'absolute'} right={'16px'}>
            {addOnProgramReviewSettings[0]?.context_data?.publish_aggregated_ratings &&
              !isNullOrEmpty(addOnProgramRatings[0]?.aggregateRating) &&
              addOnProgramRatings[0]?.aggregateRating > 0 &&
              ((readOnlyMode &&
                addOnProgramReviewSettings[0]?.context_data?.public_program_detail) ||
                (!readOnlyMode &&
                  addOnProgramReviewSettings[0]?.context_data?.program_details)) && (
                <Box
                  color={'var(--color-star-orange)'}
                  display={'flex'}
                  alignItems={'center'}
                  mt={1}
                  mb={1}
                >
                  <Star width={24} height={24} />
                  <Typography component="span" variant="body1">
                    <Box fontSize={'16px'} color={'var(--color-grey-1)'} fontWeight={500}>
                      {addOnProgramRatings[0]?.aggregateRating}
                    </Box>
                  </Typography>
                  <Typography component="span" variant="body1">
                    <Box ml={1} fontSize={'14px'} color={'var(--color-grey-3)'} fontWeight={400}>
                      ({addOnProgramRatings[0]?.totalRatings} {t('rating')})
                    </Box>
                  </Typography>
                </Box>
              )}
          </Box>

          <Box
            mb={{ xs: 2, md: 0 }}
            sx={{
              '&:before': {
                backgroundColor: 'rgb(252, 203, 0)',
              },
            }}
            className={clsx(classes.programImage, classes.programCategory)}
          >
            <Box
              mx="auto"
              width="112px"
              height="112px"
              borderRadius={8}
              className="image-container"
            >
              <img
                src={programDetail.pgm_logo ? programDetail.pgm_logo || '' : UploadImg}
                onError={(e) => {
                  e.target.onerror = null
                  e.target.src = UploadImg
                }}
                alt="program"
              />
            </Box>
          </Box>

          <Box className={classes.completedProgram} pl={{ xs: 0, sm: 3 }}>
            <Typography
              component="h4"
              variant="body1"
              className="word-break"
              gutterBottom
              tabIndex={0}
            >
              <Box fontWeight={600}>{programDetail?.pgm_attached_pgm?.pgm_name}</Box>
            </Typography>

            <Typography
              component="h6"
              align="left"
              variant="subtitle2"
              color="textPrimary"
              gutterBottom
            >
              <Box
                color={'var(--color-grey-3)'}
                component="span"
                fontWeight="500"
                fontSize="13px"
                className="block-ellipsis word-break"
              >
                {programDetail?.pgm_attached_pgm?.ap_description}
              </Box>
            </Typography>
            <Box
              flexDirection={{ xs: 'column', sm: 'row' }}
              className={classes.paymentInfo + ' payment-info'}
              display="flex"
              alignItems="center"
            >
              <Box
                color={'var(--color-grey-3)'}
                display="flex"
                alignItems="center"
                mr={2}
                position="relative"
              >
                <Box component="span" fontWeight={600} mr={0.5} fontSize={13}>
                  {t('district') + ':'}
                </Box>
                <Box component="span" fontWeight={500} fontSize={13}>
                  Excel Education System
                </Box>
              </Box>
              <Box
                color={'var(--color-grey-3)'}
                display="flex"
                alignItems="center"
                position="relative"
              >
                <Box component="span" fontWeight={600} mr={0.5} fontSize={13}>
                  {t('school') + ':'}
                </Box>
                <Box component="span" fontWeight={500} fontSize={13}>
                  Washington Technical Institute
                </Box>
              </Box>
            </Box>
            <Box component="span" fontWeight="fontWeightBold" mt={1} fontSize={12}>
              <Link
                className="text-info cursor-pointer"
                component="a"
                onClick={() =>
                  addOnProgramDetailToggle(
                    programDetail?.pgm_attached_pgm?.ap_pgm_source_id,
                    programDetail?.pgm_attached_pgm?.school_public_id
                  )
                }
              >
                {t('viewDetail')}
              </Link>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  )
}

AddOnPrograms.propTypes = {
  programDetail: PropTypes.object,
  programRatings: PropTypes.array,
  addOnProgramDetailToggle: PropTypes.func,
  readOnlyMode: PropTypes.bool,
  setCareerInstructionQuestion: PropTypes.func,
  careerInstructionFormUgly: false,
  answerTextError: PropTypes.string,
  setAnswerTextError: PropTypes.func,
  addOnProgramRatings: PropTypes.array,
  addOnProgramReviewSettings: PropTypes.array,
  addOnProgramSaved: PropTypes.array,
}

AddOnPrograms.defaultProps = {
  programDetail: {},
  programRatings: noop,
  addOnProgramDetailToggle: {},
  readOnlyMode: false,
  setCareerInstructionQuestion: noop,
  careerInstructionFormUgly: false,
  answerTextError: '',
  setAnswerTextError: noop,
  addOnProgramRatings: [],
  addOnProgramReviewSettings: [],
  addOnProgramSaved: [],
}

export default AddOnPrograms
